<template>
  <div v-if="show" :class="show?'show popup':'popup'">
    <div class="cont" :style="'width:'+width+'px'">
      <div class="popupHeader">
        <p>{{title}}</p>
        <i class="el-icon-close" @click="close" v-if="showClose"/>
      </div>
      <div class="popupCont" :style="'max-height:'+winHeight+'px'">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        winHeight: 0,
      }
    },
    props: {
      show: {
        default: false
      },
      showClose: {
        default: true
      },
      title: {
        default: '标题'
      },
      width: {
        default: 300
      }
    },
    methods: {
      close(){
        this.$emit('update:show', false);
      }
    },
    mounted(){
      let clientHeight = document.documentElement.clientHeight - 100;
      this.winHeight = clientHeight;
    }
  }
</script>

<style lang="scss" scoped>
  .popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1020;
    display: flex;
    align-items: center;
    background-color: rgba(128,128,128,0.7);
    &.show{
      .cont{
        opacity: 1;
        transform: scale(1);
      }
    }
    .cont {
      background: #fff;
      margin: auto;
      opacity: 0;
      transform: scale(0.7);
      transition: all 3s;
      .popupHeader {
        position: relative;
        color: #fff;
        text-align: center;
        padding: 10px 0;
        background-color: #335483;
        i {
          position: absolute;
          font-size: 22px;
          right: 10px;
          top: 10px;
          cursor: pointer;
        }
      }
      .popupCont {
        background: #fff;
        border: 1px solid #cdc9c9;
        padding: 10px;
        overflow-y: auto;
      }
    }
  }
</style>
